import { ChakraProvider, ColorModeScript } from "@chakra-ui/react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { ScreensProvider } from "hooks/useScreens"
import { BrowserRouter } from "react-router-dom"

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 60, 
            gcTime: 1000 * 60 * 60 * 48
        }
    }
})

const persister = createSyncStoragePersister({ storage: window.localStorage })  

export default function Providers({ children }){
    return(
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
        <ScreensProvider>
            <ChakraProvider>
                <ColorModeScript initialColorMode="light" />
                <BrowserRouter>
                    {children}
                </BrowserRouter>
            </ChakraProvider>
        </ScreensProvider>
    </PersistQueryClientProvider>
    )
}